import React, { useEffect } from "react";
import summaryStyle from "./summaryStyle";
import { Box } from "@mui/material";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import Grid from "@mui/material/Grid";
import ContractData from "./ContractData";
import ContractualPartnerData from "./ContractualPartnerData";
import ContractDescription from "./ContractDescription";
import InsuranceData from "./InsuranceData";
import { useLocation } from "react-router";
import SummaryContractDetails from "./SummaryContractDetails";
import DebtCollectionAgencyData from "./DebtCollectionAgencyData";
import { getCaseLink } from "@/src/services/productService";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import PersonalAffection from "./PersonalAffection";
import { isFlexServiceProduct } from "@/src/services/advocardService";

type SummaryProps = {
  product: AbstractCase;
  submitProps: Record<string, any>;
};

const Summary = ({ product, submitProps }: SummaryProps) => {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <ProductBox>
      <Typography variant={"h5"}>
        Ihre Angaben
      </Typography>
      <Grid container>
        <Box id={"contractData"} sx={summaryStyle.scrollToAnchor} />
        <ContractData caseData={product} />
        {product.caseCategory !== "advisory" && (
          <>
            <SummaryContractDetails caseData={product} />
            {product.name !== "dataLeakContract" && (
              <>
                <Box id={"contractualPartnerData"} sx={summaryStyle.scrollToAnchor} />
                <ContractualPartnerData title={"Angaben zum Vertragspartner"} formData={values} />
              </>
            )}
          </>
        )}
        {product.caseCategory === "defendClaim" && product.defenseProcessStatus === "debtCollection" && (
          <>
            <Box id={"debtCollectionAgencyData"} sx={summaryStyle.scrollToAnchor} />
            <DebtCollectionAgencyData title={"Angaben zum Inkassobüro"} formData={values} />
          </>
        )}
        <Box id={"contractDescription"} sx={summaryStyle.scrollToAnchor} />
        {product.name !== "dataLeakContract" && <ContractDescription title={"Beschreibung der Situation"} formData={values} />}
        {product.name === "dataLeakContract" && <PersonalAffection title={"Persönliche Betroffenheit"} product={product} />}
        <Box id={"insuranceData"} sx={summaryStyle.scrollToAnchor} />
        {!isFlexServiceProduct(product) && <InsuranceData title={"Versicherung"} formData={values} product={product} />}
      </Grid>
      <form onSubmit={handleSubmit}>
        <FormSubmit
          sx={{ marginTop: "1rem" }}
          {...submitProps}
          hideBackButton={false}
          backLink={getCaseLink(product) + "/antrag/vertrag"}
          backText={"Alles bearbeiten"}
          nextText={"Angaben speichern"}
        />
      </form>
      <EmailVerificationModal />
    </ProductBox>
  );
};

export default Summary;
